<button mat-button (click)="openInfo()">
    <fa-icon icon="circle-info"></fa-icon>
</button>
